import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import ManageGuestInformation from "./my-reservations-overview-guest-info/ManageGuestInformation";
import ManageReservationEntityInfo from "./my-reservations-overview-info/tour-overview/ManageReservationEntityInfo";
import ManageClientVoucherInformation from "./client-voucher-list/ManageClientVoucherInformation";
import VerticalTabs from "src/components/shared/vertical-tabs/VerticalTabs";
import { setSelectedItem } from "src/store/reservations/slices/ReservationsManagerSlice";
import { providerHelpers } from "src/utils/providerConfig";

const ManageTabItem = () => {
  const dispatch = useDispatch();
  const { selectedItem, isDetailView } = useSelector((state) => state.reservationsSummaryReducer);

  const tabs = [
    {
      value: "1",
      label: "Tour Overview",
      component: <ManageReservationEntityInfo isView={isDetailView} />,
    },
    {
      value: "2",
      label: "Guest Information",
      component: <ManageGuestInformation isView={isDetailView} />,
    },
    {
      value: "3",
      label: "Client Vouchers",
      component: <ManageClientVoucherInformation isView={isDetailView} />,
      disabled: !selectedItem,
    },
  ];

  useEffect(() => {
    return () => {
      dispatch(setSelectedItem(null));
    };
  }, [dispatch]);

  return <VerticalTabs tabList={tabs} />;
};

export default ManageTabItem;